import { GridFilterOperator } from '@mui/x-data-grid';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const filterOperatorTranslationMap: Record<string, string> = {
  equals: 'common.filterOperators.equals',
  is: 'common.filterOperators.equals',
  doesNotEqual: 'common.filterOperators.notEquals',
  not: 'common.filterOperators.notEquals',
  contains: 'common.filterOperators.contains',
  doesNotContain: 'common.filterOperators.notContains',
  startsWith: 'common.filterOperators.startsWith',
  endsWith: 'common.filterOperators.endsWith',
  isAnyOf: 'common.filterOperators.isAnyOf',
  isEmpty: 'common.filterOperators.isEmpty',
  isNotEmpty: 'common.filterOperators.isNotEmpty',
};

export const useTranslatedFilterOperators = (
  operators: GridFilterOperator[],
  allowedOperators?: string[],
): GridFilterOperator[] => {
  const { t } = useTranslation();
  const operatorsKey = operators.map((op) => op.value).join(',');
  const allowedKey = allowedOperators?.join(',') ?? '';

  return useMemo(() => {
    return operators
      .filter((op) => !allowedOperators || allowedOperators.includes(op.value))
      .map((op) => {
        const key = filterOperatorTranslationMap[op.value];
        if (!key) {
          //If no specific translation key exists for this operator, fall back to the operator's label
          return { ...op, label: op.label ?? '' };
        }
        return { ...op, label: t(key, { defaultValue: op.label ?? '' }) };
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, operatorsKey, allowedKey]);
};
